import CreativeList from 'common/pages/creative/CreativeList.tsx'

export const CreativeListAgency = (props: any) => <CreativeList {...props} mode={props.mode} agency/>
